import PropTypes from 'prop-types';
import React from 'react';

import { AdminPage } from '../lib/admin_layout';
import connect from 'components/lib/connect';
import IntegrationsNav from './integrations_nav';

export default connect(mapStateToProps)(IntegrationsPage);

function mapStateToProps({ getProvider }) {
  let lookupApiConfigProvider = getProvider('lookupApiConfig');
  return {
    waitingForLookupApi: lookupApiConfigProvider.isLoading() || lookupApiConfigProvider.isPending(),
  };
}

export function IntegrationsPage({ waitingForLookupApi }) {
  return (
    <AdminPage showLoading={waitingForLookupApi} className="integrations">
      <IntegrationsNav />
    </AdminPage>
  );
}

IntegrationsPage.propTypes = {
  waitingForLookupApi: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/integrations_page.jsx